import React from 'react'

export function useIsTouchDevice(): boolean {
  const [isTouchDevice, setIsTouchDevice] = React.useState(false)
  React.useEffect(() => {
    setIsTouchDevice(navigator.maxTouchPoints > 0 || 'ontouchstart' in window)
  }, [])
  return isTouchDevice
}
